import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs'
import { AuthSharedService } from '@core-lib/services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class StructureService  {
	get tenantKey() {
		return this.authService.currentTenantKey;
	}
	constructor(private http: HttpClient, private authService: AuthSharedService) {
	}

	
	updateTelephonePreference(structureId: string, telephonePreference: string): Observable<any> {
		const body = {
			structureId: structureId,
			telephone: telephonePreference
		};
		return this.http.post<any>(`${environment.apiUrl}/t/${this.tenantKey}/structure/UpdateTelephonePreference`, body);
	}
	updateEmailPreference(structureId: string, emailPreference: string): Observable<any> {
		const body = {
			structureId: structureId,
			email: emailPreference
		};
		return this.http.post<any>(`${environment.apiUrl}/t/${this.tenantKey}/structure/UpdateEmailPreference`, body);
	}

}
